import React from 'react';
import { render } from '../../../../../newRender';
import { AvatarReceived } from '../AvatarReceived';
import { isNetwork } from '../../../../../app/Domain/UseCases/Unleash/validations/IsNetwork';
import { hasCommunicationStatusFeedback } from '../../../../../app/Domain/UseCases/Unleash/validations/HasCommunicationStatusFeedback';

jest.mock(
  '../../../../../app/Domain/UseCases/Unleash/validations/IsNetwork',
  () => ({
    isNetwork: jest.fn(),
  }),
);

jest.mock(
  '../../../../../app/Domain/UseCases/Unleash/validations/HasCommunicationStatusFeedback',
  () => ({
    hasCommunicationStatusFeedback: jest.fn(),
  }),
);

describe('AvatarReceived', () => {
  it('should render the component', () => {
    const message = {
      entity: {
        picture: {
          // eslint-disable-next-line sonarjs/no-duplicate-string
          uri: 'https://example.com/picture.jpg',
        },
      },
    };
    const organization = {
      picture: {
        uri: 'https://example.com/picture.jpg',
      },
    };
    const { container } = render(
      <AvatarReceived
        message={message}
        organization={organization}
        isOrganizationPage={false}
      />,
    );
    expect(container).toBeDefined();
  });

  it('should render the component if isNetwork and hasCommunicationStatusFeedback are true', () => {
    isNetwork.mockReturnValue(true);
    hasCommunicationStatusFeedback.mockReturnValue(true);

    const message = {
      entity: {
        picture: {
          uri: 'https://example.com/picture.jpg',
        },
        fullname: 'Jane Doe',
      },
      statusSend: 'DONE',
      deleted: false,
      unread: null,
      notifications: {
        totalCount: 0,
      },
    };

    const organization = {
      picture: {
        uri: 'https://example.com/organization-picture.jpg',
      },
    };

    const { container } = render(
      <AvatarReceived
        message={message}
        organization={organization}
        isOrganizationPage={false}
      />,
    );

    expect(container).toBeDefined();
  });
});
